import React from "react";
import styles from "./styles.css";
import { PropTypes } from "prop-types";

const DistanceStepper = ({
    pathwayTracker: {
        source,
        destination,
        distance
    } = {}
}) => {
    return (
        <div styleName="styles.distance-container">
            <div styleName="styles.location-label-wrapper">
                <div styleName="styles.location-label styles.source">{source}</div>
                <div styleName="styles.location-label styles.destination">{destination}</div>
            </div>
            <div styleName="styles.distance-track">
                <div styleName="styles.track-line" />
                <div styleName="styles.track-dot left" />
                <div styleName="styles.track-dot right" />
                {distance && <div styleName="styles.distance-badge">{distance}</div>}
            </div>

        </div>

    );
};

DistanceStepper.propTypes = {
    pathwayTracker: PropTypes.object
};
export default DistanceStepper;
